import FAQSection from "@/components/site/FAQSection";
import usePageTitle from "@/hooks/usePageTitle";

export default function FAQPage() {
  usePageTitle("Frequently Asked Questions · Maqam Umrah");
  return (
    <div data-testid="page-faq">
      <section className="relative pt-32 md:pt-40 pb-8 md:pb-12 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 text-center">
          <span className="overline">Common Questions</span>
          <h1 className="font-serif text-5xl md:text-7xl text-navy mt-3 leading-[1.02] tracking-tight">
            Frequently Asked Questions
          </h1>
        </div>
      </section>
      <FAQSection hideHeader />
    </div>
  );
}
